import { useTheme, themeColors } from '../ThemeContext';
import { useTranslation } from 'react-i18next';

export type Screen = 'expo-select' | 'map' | 'ai' | 'notes' | 'profile';

interface BottomNavigationProps {
  activeScreen: Screen;
  onNavigate: (screen: Screen) => void;
}

const BottomNavigation = ({ activeScreen, onNavigate }: BottomNavigationProps) => {
  const { theme } = useTheme();
  const c = themeColors[theme];
  const { t } = useTranslation();

  const navItems: { screen: Screen; icon: string; labelKey: string }[] = [
    { screen: 'expo-select', icon: 'ri-gallery-view-2', labelKey: 'nav.expos' },
    { screen: 'map', icon: 'ri-map-2-line', labelKey: 'nav.map' },
    { screen: 'ai', icon: 'ri-sparkling-2-line', labelKey: 'nav.ai' },
    { screen: 'notes', icon: 'ri-sticky-note-2-line', labelKey: 'nav.notes' },
    { screen: 'profile', icon: 'ri-user-settings-line', labelKey: 'nav.profile' },
  ];

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 ${c.navBg} backdrop-blur-xl border-t ${c.navBorder} safe-area-bottom`}
      style={{ maxWidth: '480px', margin: '0 auto', left: '50%', transform: 'translateX(-50%)', width: '100%' }}
    >
      <div className="flex items-center justify-around px-2 py-2">
        {navItems.map(item => {
          const isActive = activeScreen === item.screen;
          return (
            <button
              key={item.screen}
              onClick={() => onNavigate(item.screen)}
              className={`flex flex-col items-center justify-center gap-1 px-4 py-2 rounded-2xl transition-all duration-300 cursor-pointer whitespace-nowrap ${
                isActive
                  ? theme === 'dark'
                    ? 'bg-[#00d4ff]/15 text-[#00d4ff]'
                    : 'bg-[#0070E0]/10 text-[#0070E0]'
                  : `${c.textMuted} hover:${c.text}`
              }`}
            >
              <div className="w-6 h-6 flex items-center justify-center relative">
                <i className={`${item.icon} text-xl`}></i>
                {isActive && (
                  <span className={`absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full ${theme === 'dark' ? 'bg-[#00d4ff]' : 'bg-[#0070E0]'}`}></span>
                )}
              </div>
              <span className={`text-[10px] font-medium ${isActive ? '' : c.textMuted}`}>{t(item.labelKey)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavigation;
